import _extends from 'babel-runtime/helpers/extends';

import ImagePreviewer from '../../../components/ImagePreviewer/index.vue';
import FileMeta from './file-meta.vue';

export default {
  components: {
    ImagePreviewer: ImagePreviewer,
    FileMeta: FileMeta
  },

  props: {
    url: {
      type: String,
      required: true
    },
    fileMeta: {
      type: Object
    },
    imageStyle: {
      type: Object
    },
    fileMetaStyle: {
      type: Object
    }
  },

  computed: {
    innerImageStyle: function innerImageStyle() {
      return _extends({
        maxWidth: '120px',
        maxHeight: '120px'
      }, this.imageStyle, {
        width: 'auto',
        height: 'auto'
      });
    }
  }
};